module.exports = __webpack_public_path__ + "success.a9b055a9.png";